module.exports = __webpack_public_path__ + "img/body-2.8c5c5ab4.png";